import StepperForm, { FormTevaRegisterProps } from '../../components/Teva/components/StepperForms/index';
import { getCep, getDoctor, getFollowupPatient, registerPatientPBM, registerFollowupPatient, registerTermsOneTrust, getOptin } from '@bforms-web/common';

const dispatchers: FormTevaRegisterProps = {
  getDoctor,
  getFollowupPatient,
  registerFollowupPatient,
  getCep,
  registerTermsOneTrust,
  getOptin,
  registerPatientPBM
};

export default function StepperFormComposer(): JSX.Element {
  return <StepperForm{...dispatchers}/>;
}